import { gql } from "@apollo/client";

export default gql`
  mutation verifyEmail($data: verifyEmailInput!){
    verifyEmail(data: $data){
        success
        data{
            cPersonId
            email
            isEmailVerified
            token
            customerId
        }
        code
        message
    }
}
`
